import { render, staticRenderFns } from "./Page.vue?vue&type=template&id=5c541c4a&scoped=true&v-bind%3Akey=%24route.path&"
import script from "./Page.vue?vue&type=script&lang=js&"
export * from "./Page.vue?vue&type=script&lang=js&"
import style0 from "./Page.vue?vue&type=style&index=0&id=5c541c4a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c541c4a",
  null
  
)

export default component.exports